module.exports = __webpack_public_path__ + "img/store.754ce3dd.jpg";